import React from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Cloud } from "./decor";

const SHADOW =
  "drop-shadow(0 16px 20px rgba(125, 155, 185, 0.28)) drop-shadow(0 3px 5px rgba(125, 155, 185, 0.18))";

const FAR = [
  { pos: "left-[4%] top-[14%] w-40 sm:w-52", opacity: 0.62, anim: "animate-drift", duration: "24s", delay: "0s" },
  { pos: "right-[9%] top-[6%] w-32 sm:w-40", opacity: 0.58, anim: "animate-floaty", duration: "20s", delay: "2s" },
  { pos: "left-[16%] top-[62%] w-36", opacity: 0.55, anim: "animate-drift", duration: "28s", delay: "4s", desktopOnly: true },
  { pos: "right-[3%] top-[54%] w-40 sm:w-52", opacity: 0.6, anim: "animate-floaty", duration: "22s", delay: "5s" },
  { pos: "left-[42%] top-[36%] w-28 sm:w-36", opacity: 0.5, anim: "animate-drift", duration: "30s", delay: "1s", desktopOnly: true },
];

const NEAR = [
  { pos: "right-[6%] top-[18%] w-64 sm:w-96", opacity: 0.85, anim: "animate-drift", duration: "18s", delay: "1s" },
  { pos: "left-[1%] top-[40%] w-52 sm:w-72", opacity: 0.8, anim: "animate-floaty", duration: "16s", delay: "3s" },
  { pos: "left-[26%] top-[80%] w-60 sm:w-96", opacity: 0.75, anim: "animate-drift", duration: "26s", delay: "2s", desktopOnly: true },
  { pos: "right-[24%] top-[86%] w-48 sm:w-72", opacity: 0.75, anim: "animate-floaty", duration: "24s", delay: "6s", desktopOnly: true },
  { pos: "left-[46%] top-[8%] w-40 sm:w-56", opacity: 0.7, anim: "animate-floaty", duration: "19s", delay: "4s" },
];

const TRAVELERS = [
  { top: "10%", cls: "w-56 sm:w-72", opacity: 0.9, duration: 90, delay: 0, bob: "animate-floaty" },
  { top: "45%", cls: "w-40 sm:w-56", opacity: 0.7, duration: 130, delay: 45, bob: "animate-drift" },
  { top: "72%", cls: "w-64 sm:w-80", opacity: 0.8, duration: 110, delay: 80, bob: "animate-floaty" },
];

const Cloudy = ({ c, i }) => (
  <Cloud
    className={`absolute ${c.pos} ${c.desktopOnly ? "hidden sm:block" : ""} ${c.anim}`}
    style={{ opacity: c.opacity, animationDuration: c.duration, animationDelay: c.delay, filter: SHADOW }}
  />
);

const Traveler = ({ c, i }) => (
  <motion.div
    className="absolute left-0"
    style={{ top: c.top }}
    initial={{ x: "-30vw" }}
    animate={{ x: "110vw" }}
    transition={{ duration: c.duration, delay: c.delay, repeat: Infinity, ease: "linear" }}
  >
    <Cloud className={`${c.cls} ${c.bob}`} style={{ opacity: c.opacity, filter: SHADOW }} />
  </motion.div>
);

export default function CloudBackdrop() {
  const { scrollY } = useScroll();
  const yFar = useTransform(scrollY, [0, 4000], [0, -110]);
  const yNear = useTransform(scrollY, [0, 4000], [0, -220]);

  return (
    <div className="fixed inset-0 -z-10 overflow-hidden pointer-events-none" aria-hidden="true" data-testid="cloud-backdrop">
      <motion.div className="absolute inset-0" style={{ y: yFar, willChange: "transform" }}>
        {FAR.map((c, i) => (
          <Cloudy key={`far-${i}`} c={c} i={i} />
        ))}
        <Traveler c={TRAVELERS[1]} i={1} />
      </motion.div>
      <motion.div className="absolute inset-0" style={{ y: yNear, willChange: "transform" }}>
        {NEAR.map((c, i) => (
          <Cloudy key={`near-${i}`} c={c} i={i} />
        ))}
        <Traveler c={TRAVELERS[0]} i={0} />
        <Traveler c={TRAVELERS[2]} i={2} />
      </motion.div>
    </div>
  );
}
